
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credite/[...bank]",
      function () {
        return require("private-next-pages/credite/[...bank].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credite/[...bank]"])
      });
    }
  